var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }